import React from "react";
import { Grid, Col, RowWrap } from "@govlaunch/core";
import { Margin } from "~/components/spacings";
import { IProduct, IGroupNewsworthyItem, IFlatResource } from "~/types/types";
import Members from "~/components/group/tabs/Members";
import Products from "~/components/group/tabs/Products";
import Newsworthy from "~/components/group/tabs/Newsworthy";
import Projects from "~/components/group/tabs/Projects";
import Resources from "~/components/group/tabs/Resources";
import Posts from "~/components/group/tabs/Posts";
import GroupGovernments from "~/components/group/GroupGovernments";
import { IGroupQuery } from "~/lib/queries/__generated__/GroupQuery.generated";
import GroupVendors from "~/components/group/GroupVendors";
import useIsMobile from "~/lib/hooks/useIsMobile";
import GroupAwards from "~/components/group/GroupAwards";
import GroupMembersSideBlock from "~/components/group/GroupMembersSideBlock";
import GroupInfo from "~/components/group/GroupInfo";
import GroupMobileNavbar from "~/components/group/GroupMobileNavbar";
import GroupResources from "~/components/group/GroupResources";
import GroupNavbar from "~/components/group/GroupNavbar";
import GroupPageSeo from "~/components/seo/GroupPageSeo";

type Content =
  | "connect"
  | "projects"
  | "products"
  | "newsworthy"
  | "members"
  | "resources"
  | "associations"
  | "governments";

interface IGroupProps {
  group: NonNullable<IGroupQuery["groupBySlug"]>;
  projectSlug?: string;
  content: Content;
}

export default function Group({ group, projectSlug, content }: IGroupProps) {
  const isMobile = useIsMobile();
  let tab = content || "connect";

  if (projectSlug) {
    tab = "projects";
  }

  return (
    <div
      css={{
        padding: "30px 0 30px",
      }}
    >
      <GroupPageSeo group={group} tab={tab} />
      <Grid>
        <RowWrap>
          <Col width={[1, 1, 1, 4 / 12]}>
            <GroupInfo group={group} />

            {isMobile && <GroupMobileNavbar group={group} tab={tab} />}

            {group.membersCount <= 6 && <GroupMembersSideBlock group={group} />}

            {!group.headedByAdmins && (
              <>
                <Margin mt={24}>
                  <GroupVendors group={group} />
                </Margin>

                <Margin mt={24}>
                  <GroupGovernments group={group} />
                </Margin>

                <Margin mt={24}>
                  <GroupAwards group={group} />
                </Margin>
              </>
            )}

            <GroupResources group={group} />
          </Col>
          <Col width={[1, 1, 1, 8 / 12]} mt={[1, 1, 1, 0]}>
            {!isMobile && <GroupNavbar group={group} tab={tab} />}

            <div
              css={{
                marginTop: 24,
              }}
            >
              {tab === "connect" && <Posts group={group} feedLimit={30} />}
              {tab === "products" && <Products products={group.products as IProduct[]} group={group} />}

              {tab === "newsworthy" && (
                <Newsworthy newsworthy={group.newsworthy as IGroupNewsworthyItem[]} group={group} />
              )}
              {tab === "members" && <Members group={group} />}
              {tab === "projects" && <Projects group={group} />}
              {tab === "resources" && <Resources resources={group.resources as IFlatResource[]} />}
            </div>
          </Col>
        </RowWrap>
      </Grid>
    </div>
  );
}
